export default __webpack_public_path__ + "static/sprite-a3169b302c6abb2de162c8ea0192994b.svg";